import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';


import Grid from '@material-ui/core/Grid';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExploreOutlinedIcon from '@material-ui/icons/ExploreOutlined';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import ViewHeadlineOutlinedIcon from '@material-ui/icons/ViewHeadlineOutlined';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import TimerOutlinedIcon from '@material-ui/icons/TimerOutlined';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';

import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
import { createUploadState, uploadSelectedFile } from '../../../../helpers/attachment-helper';
import CustomSelect from '../custom-select';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));
const VisaOfferForm = ({ handleReloadOffers, reservationReqId }) => {
    const classes = useStyles();
    const [destination, setDestination] = useState(null);
    const [visaType, setVisaType] = useState(null);
    const [visaEntry, setVisaEntry] = useState(null);
    const [error, setError] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(null);
    const [serverError, setServerError] = useState(null);
    const [attachmentUpload, setAttachmentUpload] = useState(createUploadState());

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        axios.get("/api/destination", { headers: headers })
            .then(res => { setDestination(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
        axios.get("/api/visatype", { headers: headers })
            .then(res => { setVisaType(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
        axios.get("/api/visaentry", { headers: headers })
            .then(res => { setVisaEntry(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, []);

    const handleAttachmentChange = async (event) => {
        await uploadSelectedFile({
            file: event.target.files.length > 0 ? event.target.files[0] : null,
            category: "visa",
            token: user.Token,
            setUploadState: setAttachmentUpload
        });
    };

    const submitOffer = (event) => {
        event.preventDefault();
        setLoader(true);
        setError(null);
        let visaInputs = event.target.querySelectorAll('input');
        let visaTextArea = event.target.querySelectorAll('textarea');
        let attachmentInput = event.target.querySelector(`#file-0`);

        if (attachmentUpload.uploading) {
            setError("Attachment upload is still in progress.");
            setLoader(false);
            return;
        }

        if (attachmentInput.files.length > 0 && !attachmentUpload.blobPath) {
            setError(attachmentUpload.error || "Upload the attachment before submitting the offer.");
            setLoader(false);
            return;
        }

        let visaOfferResource = new FormData();
        visaOfferResource.append("ReservationReqId", reservationReqId);
        visaOfferResource.append("OfferHeadline", event.target.querySelector("#hd-ln").value);
        visaOfferResource.append("DestinationId", parseInt(visaInputs[1].value));
        visaOfferResource.append("FromDate", visaInputs[2].value);
        visaOfferResource.append("ToDate", visaInputs[3].value);
        visaOfferResource.append("VisaTypeId", parseInt(visaInputs[4].value));
        visaOfferResource.append("VisaEntryId", parseInt(visaInputs[5].value));
        visaOfferResource.append("ProcessingDays", parseInt(visaInputs[6].value));
        visaOfferResource.append("AdultPrice", visaInputs[7].value);
        visaOfferResource.append("ChildPrice", visaInputs[8].value === "" ? 0 : parseInt(visaInputs[8].value));
        visaOfferResource.append("InfantPrice", visaInputs[9].value === "" ? 0 : parseInt(visaInputs[9].value));
        visaOfferResource.append("AttachmentFile", attachmentUpload.blobPath ? attachmentUpload.blobPath : "");
        visaOfferResource.append("Requirements", visaTextArea[0].value);
        visaOfferResource.append("Notes", visaTextArea[1].value);
        const config = {
            headers: {
                "Authorization": `Bearer ${user.Token}`,
                "Accept": "application/json",
                'content-type': 'multipart/form-data',
                "Content-Encoding": "gzip"
            }
        };

        axios.post("/api/visaoffer", visaOfferResource, config)
            .then(res => {
                setSuccess(true);
                setTimeout(() => {
                    setLoader(false);
                    handleReloadOffers();
                }, 750);
            })
            .catch(err => {
                let errorMsg = "Error Adding Offer — Try again later!";
                if (err.response && err.response.data) {
                    const data = err.response.data;
                    if (data.errors) {
                        errorMsg = Object.values(data.errors).flat().join(" | ");
                    } else if (typeof data === "string") {
                        errorMsg = data;
                    }
                }
                setServerError(errorMsg);
                setSuccess(false);
                setTimeout(() => setLoader(false), 750);
            });

    }

    return (
        <>
            <Backdrop className={classes.backdrop} open={loader} style={{ zIndex: `2000` }}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {
                destination && visaEntry && visaType ?
                    <form onSubmit={submitOffer}>
                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    id="hd-ln"
                                    label={"Offer Headline"}
                                    helperText={"Write an uniqe/request offer headline. Recommended to contain your company name and the word 'visa'(ex: CoolCompany Visa Offer 1)"}
                                    fullWidth
                                    type={"text"}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ViewHeadlineOutlinedIcon fontSize={"small"} />
                                            </InputAdornment>
                                        )
                                    }}
                                    required
                                />
                            </Grid>
                        </Grid>
                        <VisaRow
                            index={0}
                            destination={destination}
                            visaEntry={visaEntry}
                            visaType={visaType}
                            attachmentUpload={attachmentUpload}
                            onAttachmentChange={handleAttachmentChange}
                        />
                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={12} sm={6}>
                                {
                                    typeof error === "string" ?
                                        <Alert variant="filled" severity="error">{error}</Alert>
                                        : null
                                }
                                {
                                    success === false && serverError ?
                                        <Alert variant="filled" severity="error">{serverError}</Alert>
                                        : null
                                }
                                {
                                    success === true ?
                                        <Alert variant="filled" severity="success">Offer Added Successfully</Alert>
                                        : null
                                }
                            </Grid>
                        </Grid>

                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                >
                                    Submit Offer
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                    :
                    null
            }

        </>
    )
}

const VisaRow = ({ index, destination, visaType, visaEntry, attachmentUpload, onAttachmentChange }) => {
    const [_destination] = useState(destination);
    const [_visaType] = useState(visaType);
    const [_visaEntry] = useState(visaEntry);
    const [_index] = useState(index);
    return (
        <>
            <Grid container item xs={12} spacing={2}>
                <Grid item sm={6} md={4} lg={2}>
                    <CustomSelect
                        data={_destination}
                        label={"Destination"}
                        required={true}
                        icon={<ExploreOutlinedIcon fontSize={"small"} />}
                    />
                </Grid>
                <Grid item sm={6} md={4} lg={2}>
                    <TextField
                        label={"From"}
                        fullWidth
                        type={"date"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EventOutlinedIcon fontSize={"small"} />
                                </InputAdornment>
                            )
                        }}
                        required
                    />
                </Grid>
                <Grid item sm={6} md={4} lg={2}>
                    <TextField
                        label={"To"}
                        fullWidth
                        type={"date"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EventOutlinedIcon fontSize={"small"} />
                                </InputAdornment>
                            )
                        }}
                        required
                    />
                </Grid>
                <Grid item sm={6} md={4} lg={2}>
                    <CustomSelect
                        data={_visaType}
                        label={"Visa Type"}
                        required={true}
                        icon={<MoreHorizOutlinedIcon fontSize={"small"} />}
                    />
                </Grid>
                <Grid item sm={6} md={4} lg={2}>
                    <CustomSelect
                        data={_visaEntry}
                        label={"No Of Entries"}
                        required={true}
                        icon={<ExitToAppOutlinedIcon fontSize={"small"} />}
                    />
                </Grid>
                <Grid item sm={6} md={4} lg={2}>
                    <TextField
                        label={"Processing Days"}
                        fullWidth
                        type={"number"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <TimerOutlinedIcon fontSize={"small"} />
                                </InputAdornment>
                            ),
                            inputProps: { min: 1 }
                        }}
                        required
                    />
                </Grid>
                <Grid item sm={6} md={4} lg={2}>
                    <TextField
                        label={"Price/Adult"}
                        fullWidth
                        type={"number"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LocalAtmIcon fontSize={"small"} />
                                </InputAdornment>
                            ),
                            inputProps: { min: 1 }
                        }}
                        required
                    />
                </Grid>
                <Grid item sm={6} md={4} lg={2}>
                    <TextField
                        label={"Price/Child"}
                        fullWidth
                        type={"number"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LocalAtmIcon fontSize={"small"} />
                                </InputAdornment>
                            ),
                            inputProps: { min: 0 }
                        }}
                    />
                </Grid>
                <Grid item sm={6} md={4} lg={2}>
                    <TextField
                        label={"Price/Infant"}
                        fullWidth
                        type={"number"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LocalAtmIcon fontSize={"small"} />
                                </InputAdornment>
                            ),
                            inputProps: { min: 0 }
                        }}
                    />
                </Grid>
                <Grid item sm={6} md={4} lg={2}>
                    <input
                        accept=".jpg,.jpeg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.pptx,.xlsx"
                        style={{ display: `none` }}
                        id={`file-${_index}`}
                        type="file"
                        onChange={onAttachmentChange}
                    />
                    <label htmlFor={`file-${_index}`}>
                        <Button variant="outlined" color="primary" component="span">
                            Attachment
                        </Button>
                    </label>
                    {
                        attachmentUpload.uploading ?
                            <div style={{ marginTop: "8px" }}>Uploading attachment...</div>
                            : null
                    }
                    {
                        attachmentUpload.originalFileName ?
                            <div style={{ marginTop: "8px" }}>{attachmentUpload.originalFileName}</div>
                            : null
                    }
                </Grid>

                <Grid item sm={12} md={6} lg={6}>
                    <TextField
                        label="Requirements"
                        required
                        fullWidth
                        multiline
                        rows={3}
                        variant="outlined"
                    />
                </Grid>
                <Grid item sm={12} md={6} lg={6}>
                    <TextField
                        label="Notes"
                        multiline
                        fullWidth
                        rows={3}
                        variant="outlined"
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default VisaOfferForm;
